import { render, staticRenderFns } from "./RelatorioFaturamento.vue?vue&type=template&id=0374b2bf"
import script from "./RelatorioFaturamento.vue?vue&type=script&lang=js"
export * from "./RelatorioFaturamento.vue?vue&type=script&lang=js"
import style0 from "./RelatorioFaturamento.vue?vue&type=style&index=0&id=0374b2bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports